export { PostHog } from "posthog-js";
